
import api from './api';

class Brand {

	constructor (Api) {
		this.Api = Api;
	}

	get () {
		return this.Api.get({
			url:  'v1.1/m/brand'
		}).then(response => response.brand);
	}

	update (brand) {
		return this.Api.put({
			url:  'v1.1/m/brand',
			body: generatePayload(brand)
		});
	}

}

Brand.$inject = ['Api'];

export default angular.module('service.brand', [api])
	.service('Brand', Brand)
	.name;



/*
 * Helpers
 */
function generatePayload (brand) {
	var payload = new FormData();

	payload.append('description',    brand.description    || '');
	payload.append('website',        brand.website        || '');
	payload.append('facebook',       brand.facebook       || '');
	payload.append('twitter',        brand.twitter        || '');
	payload.append('instagram',      brand.instagram      || '');
	payload.append('emailCoverLink', brand.emailCoverLink || '');

	if (brand.displayOnMangootrust) {
		payload.append('displayOnMangootrust', true);
	}

	if (brand.logoFile) {
		payload.append('logo',         brand.logoFile);
	}

	if (brand.coverFile) {
		payload.append('cover',        brand.coverFile);
	}

	if (brand.emailCoverFile) {
		payload.append('emailCover',   brand.emailCoverFile);
	}

	if (brand.receiptHeaderFile) {
		payload.append('receiptHeader',   brand.receiptHeaderFile);
	}

	if (brand.receiptFooterFile) {
		payload.append('receiptFooter',   brand.receiptFooterFile);
	}

	return payload;
}




// WEBPACK FOOTER //
// ./src/service/brand.js